import mainCaller from './mainCaller';

// 다건 회원 대상 회원앱 푸시 알림 발송
export async function sendMemberPush(branchId, data, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/push/members`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}
